import { createRouter, createWebHistory } from "vue-router";
import { routes } from "vue-router/auto-routes";

// ### Excluded URL Patterns:
// COMPLETED:
// - /

// ### Static Pages:
// COMPLETED:
// - /home                                - Static? (or not?)
// - /about-us                            - Static
// - /contact-us                          - Static
// - /terms-and-conditions                - Static
// - /faqs                                - Static
// - /privacy-policy                      - Static

// ### Blog-Related Pages:
// PENDING:
// - /blog
// - /blog/[slug]
// - /category/blog                       - UI is completed, Waiting for API to be integrated
// - /tag/[slug]

// ### Shop-Related Pages:
// COMPLETED:
// - /shop
// - /product/[slug]
// - /product-category/[slug]             - Same as /shop page
// - /cart
// - /checkout
// PENDING:
// - /track-order                         - PENDING: To be continued

// ### Account-Related Pages:
// COMPLETED:
// - /my-account
//   - /orders
//   - /view-order/[id]
//   - /edit-address
//     - /billing
//     - /shipping
//   - /edit-account
//   - /customer-logout
//   - /lost-password

export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  parseQuery: (query) => Object.fromEntries(new URLSearchParams(query)),
  routes,
  scrollBehavior(_to, _from, savedPosition) {
    return savedPosition ?? { top: 0 };
  },
  stringifyQuery: (query) => query.toString(),
});

router.beforeEach(async (to, _from, next) => {
  // Mark route navigation start time
  window.performance?.mark(`route-${to.name}-start`);
  next();
});

router.afterEach((to) => {
  // Measure route navigation performance
  if (window.performance) {
    window.performance.mark(`route-${to.name}-end`);
    window.performance.measure(
      `route-${to.name}`,
      `route-${to.name}-start`,
      `route-${to.name}-end`,
    );
  }
});
